import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router';

import Title from '../../../components/Title';
import '../../../index.css';
import MyVideo from '../../../components/MyVideo';
import { getUserDetail } from '../../../modules/NetworkFunction';
import AuthContext from '../../../contexts/AuthContext';
import Pagination from '../../../components/Pagination';
import closeIcon from '../../../icons/ic-close.png';
import faceIcon from '../../../icons/ic-face_gray.png';

function MyVideoList({ history, closeModal }) {
  const { auth: token } = useContext(AuthContext);

  const [currentPage, setCurrentPage] = useState(1);
  const [video, setVideo] = useState([]);
  const [videoCount, setVideoCount] = useState(0); // 총 영상 개수
  const [nextPageToken, setNextPageToken] = useState('');
  const [YOUTUBE_API_KEY, setYOUTUBE_API_KEY] = useState(null);
  const [channelId, setChannelId] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [videoId, setVideoId] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  let videoPerPage = 0; // 페이지 별 영상 개수
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [windowWidth]);

  useEffect(() => {
    if (!isLoaded) {
      getUserDetail(
        null,
        (v) => {
          setYOUTUBE_API_KEY(v.user.youtubeAPIKey);
          setChannelId(v.user.youtubeAccount);
        },
        setIsLoaded,
        (e) => {
          console.log('getuserdetail', e);
        },
        token
      );
    }
  }, [isLoaded]);

  const getVideoList = async () => {
    try {
      const response = await axios.get(
        `https://www.googleapis.com/youtube/v3/search?part=snippet&key=${YOUTUBE_API_KEY}&channelId=${channelId}&type=video&videoEmbeddable=true&order=date&pageToken=${nextPageToken}&maxResults=40`
      );

      // console.log(response.data);
      if (nextPageToken === '') {
        setVideoCount(response.data.pageInfo.totalResults);
      }
      const newArr = video.concat(response.data.items);
      setVideo(newArr);

      if (response.data.nextPageToken) {
        setNextPageToken(response.data.nextPageToken);
      }
    } catch (e) {
      console.log('error');
    }
  };

  useEffect(() => {
    if (YOUTUBE_API_KEY && channelId) {
      getVideoList();
    }
  }, [YOUTUBE_API_KEY, channelId]);

  const videos = video.map((info, idx) => {
    if (windowWidth > 1454) {
      videoPerPage = 8;
    } else {
      videoPerPage = 4;
    }

    let start = (currentPage - 1) * videoPerPage;

    if (start <= idx && idx < start + videoPerPage) {
      return (
        <MyVideo
          key={idx}
          videoId={info.id.videoId}
          img={info.snippet.thumbnails.high.url}
          title={info.snippet.title}
          date={info.snippet.publishedAt.substring(0, 10)}
          handleCheckVideo={() => {
            handleCheckVideo(info.id.videoId);
          }}
          selectedVideoId={videoId}
        />
      );
    }
  });

  const handleCheckVideo = React.useCallback((vId) => {
    setVideoId(vId);
  });

  const empty = (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        height: 540,
      }}
    >
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <div>
            <img src={faceIcon} alt="등록된 영상이 없습니다." />
          </div>
          <div style={{ marginTop: 10 }}>
            <p style={{ color: '#848484', fontSize: 22 }}>
              유튜브에 등록된 영상이 없습니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="inner" style={{ width: '90%', margin: 'auto' }}>
      <div
        style={{
          // width: '100%',
          // height: '100%',
          // borderRadius: 10,
          // backgroundColor: 'white',
          // display: 'flex',
          // flexDirection: 'column',
          height: '95vh',
          margin: 'auto',
          padding: '20px 0',
          position: 'relative',
        }}
      >
        <div
          style={{
            display: 'block',
            flexDirection: 'row',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Title title="내 유튜브 영상" />
          <button
            className="close"
            style={{ position: 'absolute', top: 24, right: 0 }}
          >
            <img
              onClick={closeModal}
              style={{ cursor: 'pointer' }}
              src={closeIcon}
              alt="닫기"
            />
          </button>
        </div>

        {videos.length !== 0 ? (
          <div
            style={{
              display: 'flex',
              marginTop: 50,
              height: 540,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignContent: 'flex-start',
                justifyContent: 'space-between',
              }}
            >
              {videos}
            </div>
          </div>
        ) : (
          empty
        )}

        <div
          style={{
            marginTop: 50,
          }}
        >
          <Pagination
            currentPage={currentPage}
            itemsPerPage={videoPerPage}
            totalItems={videoCount}
            paginate={setCurrentPage}
            handleNextPageGroup={getVideoList}
          />
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            position: 'absolute',
            bottom: 20,
            right: 0,
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <button
              className={videoId ? 'normal-button-y' : 'normal-button-g'}
              style={{
                display: 'flex',
                height: 40,
                borderRadius: 20,
                fontSize: 20,
                borderWidth: 0,

                fontStyle: 'normal',
                fontWeight: 700,
                padding: '10px 30px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={() => {
                videoId
                  ? history.push({
                      pathname:
                        '/mypage/contents-making/contents-modal/content-regist',
                      state: {
                        videoId,
                        ...location.state,
                        isModify: location.state?.isModify ?? false,
                      },
                    })
                  : alert('영상을 선택해주세요.');
              }}
            >
              저장
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyVideoList;
